import React, { useMemo, useState } from "react";
import { Container, Col, Row, Form, Modal, Image, Tab } from "react-bootstrap";
import "../../Assets/css/productlist.css";
import Button from "@mui/material/Button";
import AppsIcon from "@mui/icons-material/Apps";
import ListIcon from "@mui/icons-material/List";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Pagination from "@mui/material/Pagination";
import eye from "../../Assets/images/eye.svg";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import cart from "../../Assets/images/cart.png";
import inquir from "../../Assets/images/inquir.svg";
import {
  makeStyles,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  base_url,
  client_name,
  postHeader,
} from "../../Helpers/request";
import { currencyCode } from "../../Reducer/homeReducer";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import { sessionId } from "../../Reducer/homeReducer";
import { useCallback } from "react";
import { Skeleton } from "@mui/material";
import { set } from "date-fns";

const Searchlist = (props) => {
  const history = useHistory();
  const { search_text } = useParams();
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const [view, setView] = useState(1);
  const [inquiry, setInquiry] = useState(false);
  const [quickView, setQuickView] = useState(false);
  const [listdata, setListdata] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const handleCloseInquiry = () => setInquiry(false);
  const handleShowInquiry = () => setInquiry(true);
  const handleCloseQuickView = () => setQuickView(false);
  const [quickdata, setQuickdata] = React.useState([]);
  const [expanded, setExpanded] = React.useState([]);
  const [paramid, setParamid] = useState(
    props.location.pathname.includes("/bags")
      ? "bags"
      : props.match.params.listcategory
      ? props.match.params.listcategory
      : props.match.params.search_text
  );

  const [productid, setProductid] = useState("");
  const [loader, setLoader] = useState(true);
  const [proIndex, setProIndex] = useState("");
  const [searchType, setSearchType] = useState("watches");
  const [noData , setNoData] = useState(false)
  const dispatch = useDispatch();
 const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  useEffect(() => {
    if (search_text) {
      searchProducts();
    }
  }, [search_text]);

   const searchProducts = async () => {
    const searchData = {
      currency_code: "USD",
      search_text: search_text ? search_text : "",
    };
    await axios
      .post(base_url + "/common/search", searchData, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          if (res.data.data?.length === 0) {
            setNoData(true);
          }
          setListdata(res?.data?.data)
          setLoader(false)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
 
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {paramid?.charAt(0).toUpperCase() +
            paramid.slice(1).replace("-", " ")}
          | {client_name.c_name}
        </title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_product_list_main search_list_page">
        <Container className="rcs_customer_container rcs_large_container mt-3">
          <Row>
            <Col sm={12} className="p-md-0">
              <div className="rcs_bread_crumb">
                <div className="rcs_category_title">
                  <h2>
                    Search Result(s) for <strong>"{search_text}"</strong>
                  </h2>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            {/* mj product list */}
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              className="rcs_list_tablet p-lg-0"
            >
              <div className="rcs_product_list_wrapper">
                <div className="rcs_view">
                  <div>
                    <div className="rcs_mob_filter1">
                      <span> View</span>
                      <AppsIcon
                        className={view == 1 ? "active_grid ml-2" : "ml-2"}
                        onClick={() => setView(1)}
                      />
                      <span style={{ borderRight: "1px solid #ccc" }}></span>
                      <ListIcon
                        className={view == 2 ? "active_grid ml-2" : "ml-2"}
                        onClick={() => setView(2)}
                      />
                    </div>
                  </div>
                </div>
                 {view === 1 ? (
                  <div className="rcs_product_grid">
                    <Row>
                      {listdata?.length ? (
                        listdata?.map((val, index) => (
                          <Col className="mg_nopadd" xs={6} sm={6} md={4}>
                            <div className="rcs_product_item position-relative">
                              {loader ? (
                                <div className="rcs_filter_prod_wrapper">
                                  <CircularProgress className="rcs_filter_prod_loader" />
                                </div>
                              ) : (
                                ""
                              )}
                              <NavLink
                                to={val?.url}
                              >
                                <div class="color-overlay"></div>
                                {val?.image ? (
                                  <img
                                    src={val?.image}
                                    alt="product image"
                                  ></img>
                                ) : ""
                                }
                              </NavLink>
                              <div className="rcs_prod_info">
                                <div className="d-flex align-items-start js_space pt-10">
                                  <h2
                                    onClick={() => {
                                      history.push(val?.url);
                                      window.scrollTo(0, 0);
                                    }}
                                    className="rcs_list_title"
                                  >
                                    {val?.title}
                                  </h2>
                                </div>
                                 <p className="rcs_emailprice">
                                    {val?.is_price == 1
                                      ? val?.currency_icon + val?.price
                                      : "Email us for Price"}
                                  </p>
                              </div>
                            </div>
                          </Col>
                        ))
                      ) : noData ? (
                        <h4 className="mt-5 mb-5 text-center">
                          No Search Result(s) founded for
                          <strong>"{search_text}"</strong>
                        </h4>
                      ) : (
                        Array.from({ length: 18 }).map((_, index) => (
                          <Skeleton
                            key={index}
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={350}
                            height={350}
                            className="m-3"
                          />
                        ))
                      )}
                    </Row>
                  </div>
                ) : noData == false && listdata?.length ? (
                  listdata?.map((val, index) => (
                    <div className="rcs_prodlist_item mb-2">
                      <Row>
                        <Col className="mg_nopad" xs={5} sm={5} md={4}>
                          <div className="rcs_product_item rcs_list_img">
                            <NavLink
                              to={val.url}
                            >
                              <div className="color-overlay"></div>
                                <img src={val?.image}></img>
                            </NavLink>
                          </div>
                        </Col>
                        <Col className="mg_nopad" xs={7} sm={7} md={8}>
                          <div className="rcs_prod_list_info">
                            <div className="d-flex align-items-start pt-10">
                              <h2 className="rcs_list_title">{val.title}</h2>
                            </div>
                            {val.is_price !== "0" ? (
                              <p className="rcs_main_price">
                                {val.currency_icon}
                                {val.price}
                              </p>
                            ) : (
                              <p className="rcs_list_email">
                                Email us for Price
                              </p>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))
                ) : noData ? (
                  <h4 className="mt-5 mb-5 text-center">
                    No Search Result(s) founded for
                    <strong>"{search_text}"</strong>
                  </h4>
                ) : (
                  Array.from({ length: 18 }).map((_, index) => (
                    <Skeleton
                      key={index}
                      variant="text"
                      style={{ transform: "unset" }}
                      animation="wave"
                      width={"100%"}
                      height={230}
                      className="m-3"
                    />
                  ))
                )}
                {/* product list pagination */}
              </div>
              {/* </div> */}
            </Col>
          </Row>

        </Container>
      </div>
    </>
  );
};
export default Searchlist;
